import React from "react";
import { NavLink } from "react-router-dom";
export default function alert(props) {
    
  return (
    <div style={{height:'60px'}}>
    
   {props.alert &&<div className="alert alert-success fade show mx-5" role="alert">
   <strong>{props.alert.type} </strong>{props.alert.msg}
   </div>}
 </div>
   
  );
}
